export const SOURCE_SYSTEM = 'AREA_PRIVADA'